module.exports = __webpack_public_path__ + "img/invoice-file.c91ef86d.svg";